import "./index.css";
const Scope = ({ scope, filled }) => (
  <span className={`scope ${filled ? "filled" : "outlined"}`}>{scope}</span>
);

const GraphicIcon = ({ icon }) => (
  <img src={icon} width={18} height={18} alt="Graphic Icon" />
);
const SubHeaderBoxGray = ({
  title,
  scope,
  scopes,
  graphicIcons,
  description,
  icon,
}) => {
  return (
    <div className="sub-header-box-gray" style={{ display: "flex" }}>
      <div style={{ marginRight: "20px" }}>
        <img src={icon} alt="Subgroup Icon" width={60} height={60} />
      </div>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h5>{title}</h5>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div className="scopes">
              {scopes?.map((scope, index) => (
                <Scope key={index} {...scope} />
              ))}
            </div>
            {graphicIcons && (
              <div className="graphic-icons">
                {graphicIcons?.map((icon, index) => (
                  <GraphicIcon key={index} {...icon} />
                ))}
              </div>
            )}
          </div>
        </div>
        {scope && <p style={{ padding: 0, marginBottom: "5px" }}>{scope}</p>}
        <p
          style={{
            maxWidth: "100%",
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default SubHeaderBoxGray;
